import React from "react";
import { createRoot } from "react-dom/client";
// import '@shopify/polaris/styles.css';
// import '@shopify/polaris/dist/styles.css' @6.1.0;
// import "@shopify/polaris/build/esm/styles.css?inline"; //@7.0.0
import '@shopify/polaris/build/esm/styles.css';
import Router from "./Router";
// import CWComponentsProvider from "./components/CWComponentsProvider"
import * as serviceWorker from "./serviceWorker";
// import MyEditor from './components/Editor/CKEditor';
import {Provider} from "react-redux"
import { store } from './store';
import reportWebVitals from './reportWebVitals'
// import {AppProvider} from '@shopify/polaris';
// import {onLCP} from 'web-vitals';
// import { reqGetCls } from "./api";
import { BrowserRouter } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";

// function sendToAnalytics(metric) {
//   // Replace with whatever serialization method you prefer.
//   // Note: JSON.stringify will likely include more data than you need.
//   // const body = JSON.stringify(metric);
//   let url = window.location.href;
//   let value = metric.value;
  
//   // Use `navigator.sendBeacon()` if available, falling back to `fetch()`.
//   if (Number(metric.value) > 2000) {
//     // (navigator.sendBeacon && navigator.sendBeacon(API_DOMAIN+'/api/v1/black/cls?url='+url+'&cls='+value, body)) ||
//     if (process.env.REACT_APP_ENV === 'pre') {
//       reqGetCls({url, cls:value});
//     }
//   }
  
// }


const App = () => {
  // useEffect(() => {
  //   // onCLS(sendToAnalytics, { reportAllChanges: true });
    
  //   onLCP(sendToAnalytics, { reportAllChanges: true });
  // }, []); // 空依赖数组确保只运行一次
  return (<DndProvider backend={HTML5Backend} context={window}>
    {/* <AppProvider> */}
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      {/* <AppProvider> */}
     <BrowserRouter>
      <Router />
      {/* <CWComponentsProvider /> */}
      </BrowserRouter>
      {/* </AppProvider> */}
      </QueryClientProvider>
    </Provider>
    {/* </AppProvider>  */}
    </DndProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// 在应用启动后动态加载第三方脚本，避免影响首屏LCP
(function() {
  function loadThirdPartyScripts() {
    var script = document.createElement('script');
    script.src = '/third-party-scripts.js?v='+new Date().getTime();
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  
  // 使用 requestIdleCallback 在浏览器空闲时加载，或延迟加载
  if (window.requestIdleCallback) {
    requestIdleCallback(loadThirdPartyScripts, { timeout: 2000 });
  } else {
    // 降级方案：延迟加载
    setTimeout(loadThirdPartyScripts, 1000);
  }
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'test') {
reportWebVitals(console.log);
// }
